<template>
  <div class='opc-cart-item__text first-capitalize'>
    <slot>
      <vloader v-if='isZuoraOutage' :loading='loading' :value='zuoraOutageChargeDate' />
      <template v-else>
        {{ $t('billing.order_summary.next_charge_date') + ' ' }}
        <vloader :loading='loading' :value='chargeDate' />
      </template>
    </slot>
  </div>
</template>
<script>
import vloader from '@/views/config/shopping-cart/prorated/vloader.vue';
import { mapGetters } from 'vuex';
import nextMixin from '@/views/config/shopping-cart/nextMixin';
import { BILLING_CYCLE } from '@/common/constants';
import { dateTimeFormat } from '@/utils/dateformat';

export default {
  mixins: [nextMixin],
  components: { vloader },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    billingCycle: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['nextChargeDate', 'isZuoraOutage']),
    chargeDate() {
      return this.nextDateFromServer || this.mx__deprecated__nextDate(new Date(), this.billingCycle, true);
    },
    zuoraOutageChargeDate() {
      return this.$t('billing.zuoraoutage.expire_date', [this.chargeDate]);
    },
    nextDateFromServer() {
      const dateKey = {
        [BILLING_CYCLE.MONTHLY]: 'nextMonthlyDate',
        [BILLING_CYCLE.ANNUAL]: 'nextAnnualDate',
        [BILLING_CYCLE.QUARTERLY]: 'nextQuarterlyDate',
        [BILLING_CYCLE.TWO_YEARS]: 'nextTwoYearsDate',
        [BILLING_CYCLE.THREE_YEARS]: 'nextThreeYearsDate',
      }[this.billingCycle];
      const nextDate = this.nextChargeDate[dateKey];
      if (nextDate) {
        return dateTimeFormat(nextDate);
      }
      return null;
    },
  },
};
</script>
